import React, { Component } from 'react'

export default class AddToDo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            todo: ""
        }
    }

    handleToDoChange(e) {
        this.setState({ todo: e.target.value })
    }

    handleAdd() {
        this.props.onAdd(this.state.todo)
        this.setState({ todo: "" })
    }

    render() {
        return (
            <div className="input-group mb-3">
                <input type="text" className="form-control" placeholder="to-do item" value={this.state.todo} onChange={(e) => this.handleToDoChange(e)} />
                <div className="input-group-append">
                    <button className="btn btn-outline-secondary" type="button" disabled={!this.state.todo} onClick={() => this.handleAdd()}>+</button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AddToDo.jsx